import icon from 'vue-svgicon';

icon.register({
    'regular/hand-expand': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M7.863 20.258l-4.6-5.108a1.564 1.564 0 0 1-.139-1.913h0a1.564 1.564 0 0 1 2.105-.473L7.7 14.247 6.4 5.163A1.585 1.585 0 0 1 7.591 3.4h0A1.585 1.585 0 0 1 9.53 4.628L10.7 10.5V3.747a1.5 1.5 0 0 1 1.5-1.5h0a1.5 1.5 0 0 1 1.5 1.5V10.5l1.182-5.911a1.545 1.545 0 0 1 1.889-1.2h0a1.544 1.544 0 0 1 1.14 1.8L16.7 11.247l2.3-4.59a1.391 1.391 0 0 1 2.016-.536h0a1.392 1.392 0 0 1 .52 1.674l-2.259 5.648a4.491 4.491 0 0 0-.322 1.671v2.133a4.5 4.5 0 0 1-1.8 3.6h0a4.5 4.5 0 0 1-2.7.9h-3.247a4.5 4.5 0 0 1-3.345-1.489z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
